import * as React from "react"
import { PlaylistInteractionContext } from "./PlaylistInteractionContext.tsx"

// PlaylistInteractionProvider
// -------------------------------------------------------------
// This provider is responsible for managing the state of the active playlist
// within the audio context. Its goal is to decouple playlist selection logic from
// playback logic, allowing different components to access or modify the active playlist
// without mixing responsibilities
//
// Reasons for use:
// - Allows the UI and other components to know which playlist is currently selected.
// - Prevents duplicating state in other providers (such as the playback provider).
// - Improves scalability and maintainability by keeping responsibilities separated.
// - If playback logic needs to know the active playlist, it can consume this context.
//
// Use this provider whenever you need to read or modify the active playlist anywhere
// in the audio-related part of the app, without coupling it to playback logic.
// -------------------------------------------------------------

export const PlaylistInteractionProvider = ({ children }: { children: React.ReactNode }) => {
  const [activePlaylistId, setActivePlaylistId] = React.useState<string | null>(null)
  const setActivePlaylist = (id: string) => setActivePlaylistId(id)
  const clearActivePlaylist = () => setActivePlaylistId(null)

  return (
    <PlaylistInteractionContext.Provider
      value={{
        activePlaylistId,
        setActivePlaylist,
        clearActivePlaylist
      }}
    >
      {children}
    </PlaylistInteractionContext.Provider>
  )
}
